// 简单的拼音转换工具
// 由于完整的拼音库较大，这里提供一个简化版本
// 如果需要更准确的拼音转换，可以使用 pinyin-pro 或 pinyin 库

// 常用城市拼音映射表（简化版）
const cityPinyinMap = {
  '北京': 'beijing',
  '上海': 'shanghai',
  '广州': 'guangzhou',
  '深圳': 'shenzhen',
  '天津': 'tianjin',
  '杭州': 'hangzhou',
  '南京': 'nanjing',
  '苏州': 'suzhou',
  '武汉': 'wuhan',
  '长沙': 'changsha',
  '成都': 'chengdu',
  '重庆': 'chongqing',
  '西安': 'xian',
  '郑州': 'zhengzhou',
  '济南': 'jinan',
  '青岛': 'qingdao',
  '大连': 'dalian',
  '沈阳': 'shenyang',
  '哈尔滨': 'haerbin',
  '长春': 'changchun',
  '石家庄': 'shijiazhuang',
  '太原': 'taiyuan',
  '呼和浩特': 'huhehaote',
  '合肥': 'hefei',
  '福州': 'fuzhou',
  '厦门': 'xiamen',
  '南昌': 'nanchang',
  '南宁': 'nanning',
  '海口': 'haikou',
  '昆明': 'kunming',
  '贵阳': 'guiyang',
  '拉萨': 'lasa',
  '兰州': 'lanzhou',
  '西宁': 'xining',
  '银川': 'yinchuan',
  '乌鲁木齐': 'wulumuqi',
  '无锡': 'wuxi',
  '常州': 'changzhou',
  '温州': 'wenzhou',
  '嘉兴': 'jiaxing',
  '湖州': 'huzhou',
  '绍兴': 'shaoxing',
  '金华': 'jinhua',
  '台州': 'taizhou',
  '宁波': 'ningbo',
  '舟山': 'zhoushan',
  '徐州': 'xuzhou',
  '南通': 'nantong',
  '连云港': 'lianyungang',
  '淮安': 'huaian',
  '盐城': 'yancheng',
  '扬州': 'yangzhou',
  '镇江': 'zhenjiang',
  '泰州': 'taizhou',
  '宿迁': 'suqian',
  '芜湖': 'wuhu',
  '蚌埠': 'bengbu',
  '淮南': 'huainan',
  '马鞍山': 'maanshan',
  '淮北': 'huaibei',
  '铜陵': 'tongling',
  '安庆': 'anqing',
  '黄山': 'huangshan',
  '滁州': 'chuzhou',
  '阜阳': 'fuyang',
  '宿州': 'suzhou',
  '六安': 'liuan',
  '亳州': 'bozhou',
  '池州': 'chizhou',
  '宣城': 'xuancheng',
  '莆田': 'putian',
  '三明': 'sanming',
  '泉州': 'quanzhou',
  '漳州': 'zhangzhou',
  '南平': 'nanping',
  '龙岩': 'longyan',
  '宁德': 'ningde',
  '景德镇': 'jingdezhen',
  '萍乡': 'pingxiang',
  '九江': 'jiujiang',
  '新余': 'xinyu',
  '鹰潭': 'yingtan',
  '赣州': 'ganzhou',
  '吉安': 'jian',
  '宜春': 'yichun',
  '抚州': 'fuzhou',
  '上饶': 'shangrao',
  '淄博': 'zibo',
  '枣庄': 'zaozhuang',
  '东营': 'dongying',
  '烟台': 'yantai',
  '潍坊': 'weifang',
  '济宁': 'jining',
  '泰安': 'taian',
  '威海': 'weihai',
  '日照': 'rizhao',
  '临沂': 'linyi',
  '德州': 'dezhou',
  '聊城': 'liaocheng',
  '滨州': 'binzhou',
  '菏泽': 'heze',
  '开封': 'kaifeng',
  '洛阳': 'luoyang',
  '平顶山': 'pingdingshan',
  '安阳': 'anyang',
  '鹤壁': 'hebi',
  '新乡': 'xinxiang',
  '焦作': 'jiaozuo',
  '濮阳': 'puyang',
  '许昌': 'xuchang',
  '漯河': 'luohe',
  '三门峡': 'sanmenxia',
  '南阳': 'nanyang',
  '商丘': 'shangqiu',
  '信阳': 'xinyang',
  '周口': 'zhoukou',
  '驻马店': 'zhumadian',
  '济源': 'jiyuan',
  '黄石': 'huangshi',
  '十堰': 'shiyan',
  '宜昌': 'yichang',
  '襄阳': 'xiangyang',
  '鄂州': 'ezhou',
  '荆门': 'jingmen',
  '孝感': 'xiaogan',
  '荆州': 'jingzhou',
  '黄冈': 'huanggang',
  '咸宁': 'xianning',
  '随州': 'suizhou',
  '株洲': 'zhuzhou',
  '湘潭': 'xiangtan',
  '衡阳': 'hengyang',
  '邵阳': 'shaoyang',
  '岳阳': 'yueyang',
  '常德': 'changde',
  '张家界': 'zhangjiajie',
  '益阳': 'yiyang',
  '郴州': 'chenzhou',
  '永州': 'yongzhou',
  '怀化': 'huaihua',
  '娄底': 'loudi',
  '韶关': 'shaoguan',
  '珠海': 'zhuhai',
  '汕头': 'shantou',
  '佛山': 'foshan',
  '江门': 'jiangmen',
  '湛江': 'zhanjiang',
  '茂名': 'maoming',
  '肇庆': 'zhaoqing',
  '惠州': 'huizhou',
  '梅州': 'meizhou',
  '汕尾': 'shanwei',
  '河源': 'heyuan',
  '阳江': 'yangjiang',
  '清远': 'qingyuan',
  '东莞': 'dongguan',
  '中山': 'zhongshan',
  '潮州': 'chaozhou',
  '揭阳': 'jieyang',
  '云浮': 'yunfu',
  '柳州': 'liuzhou',
  '桂林': 'guilin',
  '梧州': 'wuzhou',
  '北海': 'beihai',
  '防城港': 'fangchenggang',
  '钦州': 'qinzhou',
  '贵港': 'guigang',
  '玉林': 'yulin',
  '百色': 'baise',
  '贺州': 'hezhou',
  '河池': 'hechi',
  '来宾': 'laibin',
  '崇左': 'chongzuo',
  '三亚': 'sanya',
  '三沙': 'sansha',
  '儋州': 'danzhou',
  '自贡': 'zigong',
  '攀枝花': 'panzhihua',
  '泸州': 'luzhou',
  '德阳': 'deyang',
  '绵阳': 'mianyang',
  '广元': 'guangyuan',
  '遂宁': 'suining',
  '内江': 'neijiang',
  '乐山': 'leshan',
  '南充': 'nanchong',
  '眉山': 'meishan',
  '宜宾': 'yibin',
  '广安': 'guangan',
  '达州': 'dazhou',
  '雅安': 'yaan',
  '巴中': 'bazhong',
  '资阳': 'ziyang'
}

// 获取城市全拼
export function getFullSpell(city) {
  return cityPinyinMap[city] || ''
}

// 城市首字母映射表（手动维护，确保准确性）
const cityInitialsMap = {
  '北京': 'BJ',
  '上海': 'SH',
  '广州': 'GZ',
  '深圳': 'SZ',
  '天津': 'TJ',
  '杭州': 'HZ',
  '南京': 'NJ',
  '苏州': 'SZ',
  '武汉': 'WH',
  '长沙': 'CS',
  '成都': 'CD',
  '重庆': 'CQ',
  '西安': 'XA',
  '郑州': 'ZZ',
  '济南': 'JN',
  '青岛': 'QD',
  '大连': 'DL',
  '沈阳': 'SY',
  '哈尔滨': 'HEB',
  '长春': 'CC',
  '石家庄': 'SJZ',
  '太原': 'TY',
  '呼和浩特': 'HHHT',
  '合肥': 'HF',
  '福州': 'FZ',
  '厦门': 'XM',
  '南昌': 'NC',
  '南宁': 'NN',
  '海口': 'HK',
  '昆明': 'KM',
  '贵阳': 'GY',
  '拉萨': 'LS',
  '兰州': 'LZ',
  '西宁': 'XN',
  '银川': 'YC',
  '乌鲁木齐': 'WLMQ',
  '无锡': 'WX',
  '常州': 'CZ',
  '温州': 'WZ',
  '嘉兴': 'JX',
  '湖州': 'HZ',
  '绍兴': 'SX',
  '金华': 'JH',
  '台州': 'TZ',
  '宁波': 'NB',
  '舟山': 'ZS'
}

// 获取城市首字母（简化为取每个字的拼音首字母）
export function getInitials(city) {
  // 优先使用映射表
  if (cityInitialsMap[city]) {
    return cityInitialsMap[city]
  }
  
  const fullSpell = getFullSpell(city)
  if (!fullSpell) {
    // 如果没有映射，返回空字符串（避免错误）
    return ''
  }
  
  // 提取首字母（每个字的拼音首字母）
  // 使用正则表达式匹配拼音音节（不使用单词边界，因为拼音是连续的）
  // 拼音音节模式：辅音(可选) + 元音 + 可选尾音(ng/n)
  // 例如：beijing -> bei, jing
  const syllablePattern = /([bpmfdtnlgkhjqxzcsryw]*[aeiouü]+[ng]?)/gi
  const syllables = []
  let match
  
  // 使用 exec 来匹配所有音节
  while ((match = syllablePattern.exec(fullSpell)) !== null) {
    syllables.push(match[1])
  }
  
  if (syllables.length > 0) {
    // 提取每个音节的第一个字母
    return syllables.map(syllable => {
      const firstChar = syllable.charAt(0)
      // 如果音节以元音开头（如 ang, eng），则取元音本身
      // 如果以辅音开头，取辅音
      return firstChar.toUpperCase()
    }).join('')
  }
  
  // 如果无法匹配音节，使用智能分割
  // 对于 beijing 这种情况，查找第二个辅音字母
  let result = fullSpell[0].toUpperCase()
  
  // 查找第二个音节的开始（通常是第二个辅音字母）
  for (let i = 1; i < fullSpell.length; i++) {
    const char = fullSpell[i]
    // 如果是辅音字母，且前面是元音或辅音+元音组合，则可能是新音节的开始
    if (/[bpmfdtnlgkhjqxzcsryw]/.test(char)) {
      // 检查前面是否有元音
      let hasVowelBefore = false
      for (let j = i - 1; j >= 0 && j >= i - 3; j--) {
        if (/[aeiouü]/.test(fullSpell[j])) {
          hasVowelBefore = true
          break
        }
      }
      if (hasVowelBefore) {
        result += char.toUpperCase()
        break
      }
    }
  }
  
  // 如果还是只有一个字母，尝试简单方法：取前两个不同的辅音
  if (result.length === 1) {
    const consonants = fullSpell.match(/[bpmfdtnlgkhjqxzcsryw]/gi) || []
    if (consonants.length >= 2) {
      result = (consonants[0] + consonants[1]).toUpperCase()
    } else if (fullSpell.length >= 2) {
      result = fullSpell.substring(0, 2).toUpperCase()
    }
  }
  
  return result || fullSpell.substring(0, 2).toUpperCase()
}

// 拼音工具对象
export const pinyin = {
  getFullSpell,
  getInitials
}

